<template>
  <svg aria-hidden="true" :style="{ width: iconSize, height: iconSize }">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  props: {
    iconClass: {
      type: String,
      required: true
    },
    size: {
      type: Number | String,
      default: ''
    }
  },
  computed: {
    iconName () {
      return `#icon-${this.iconClass}`
    },
    iconSize () {
      if (this.size) {
        return this.size + 'px'
      }
      else {
        return '16px'
      }
    }
  }
}
</script>
